<template>
  <button
    :class="value.class"
    class="btn btn-sm"
    :disabled="value.disabled"
    @click.prevent="click"
    style="font-size: 10px; width: 106px"
  >
    <i v-if="value.icon" :class="value.icon"></i>
    {{ value.content }}
  </button>
</template>

<script>
export default {
  name: "button-td",
  props: ["value"],

  methods: {
    click() {
      this.value.action(this.value.id);
    },
  },
};
</script>
